module.exports = __webpack_public_path__ + "img/rainbowmakivogelperspektive.69812c0e.jpg";